import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import { isProduction } from '../../../config';

const useStyles = makeStyles(() => ({
  hintIcon: {
    fontSize: '12px',
    marginLeft: '4px',
    color: '#999999',
    cursor: 'help',
    verticalAlign: 'super',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  tooltip: {
    whiteSpace: 'pre-line',
    // maxWidth: '300px',
  },
}));

interface HintIconProps {
  hint?: string;
  marginRight?: boolean;
}

export const HintIcon = ({ hint, marginRight }: HintIconProps): JSX.Element | null => {
  const classes = useStyles();

  if (!hint || isProduction) {
    return null;
  }

  return (
    <Tooltip title={hint} placement="top" classes={{ tooltip: classes.tooltip }}>
      <InfoIcon className={classes.hintIcon} style={{ marginRight: marginRight ? '-16px' : '0' }} />
    </Tooltip>
  );
};
